<template>
  <div class="bg-gray-700 font-sans text-white antialiased">
    <Navbar
      v-bind:class="{
        'bg-gray-700': !heroVisibility,
        'bg-transparent': heroVisibility,
      }"
    />
    <div class="py-16">
      <div
        class="container mx-auto mt-8 max-w-3xl px-4 leading-relaxed sm:px-8"
      >
        <div class="article-header">
          <h1 class="font-raleway text-5xl font-bold tracking-normal">
            RGPD, Informatique et Libertés
          </h1>
        </div>
        <div class="article-content">
          <h2 class="font-raleway text-3xl font-bold text-green-500">
            Protection des données personnelles et politique de confidentialité
            d'HerdingCats et HerdingCam
          </h2>
          <h3 class="mt-4 text-2xl font-bold">Informations générales</h3>
          <p>
            Avec l’autorisation explicite de l’utilisateur, obtenue via un
            formulaire, les données transmises sont conservées par la société
            Blackfoot, éditeur des applications HerdingCats et HerdingCam,
            conformément aux recommandations en vigueur. Ces données sont
            exclusivement utilisées par Blackfoot et ne sont ni cédées ni louées
            à des tiers.
          </p>
          <h3 class="mt-4 text-2xl font-bold">Utilisation des données</h3>
          <p>
            Les informations recueillies par les applications HerdingCats et
            HerdingCam sont traitées informatiquement pour permettre le suivi
            des échanges entre l’utilisateur et les collaborateurs de Blackfoot.
            Elles peuvent être utilisées à des fins informatives, toujours dans
            le cadre des applications HerdingCats et HerdingCam. Seuls les
            collaborateurs de Blackfoot travaillant sur les applications
            HerdingCats et HerdingCam ont accès à ces données.
          </p>
          <h3 class="mt-4 text-2xl font-bold">Droits de l'utilisateur</h3>
          <p>
            Conformément à la
            <a
              href="https://www.cnil.fr/fr/la-loi-informatique-et-libertes"
              class="text-green-500 hover:underline focus:underline"
              >loi « Informatique et libertés » du 6 janvier 1978</a
            >, l'utilisateur de l'application HerdingCats et/ou de l'application
            HerdingCam bénéficie d'un droit d'accès, de rectification, de
            modification et de suppression des informations qui le concernent.
            S'il souhaite exercer ce droit et obtenir communication des
            informations le concernant, il peut s'adresser à Blackfoot&nbsp;:
          </p>
          <br />
          <ul class="list-disc pl-6">
            <li>
              Par mail&nbsp;:
              <a
                href="mailto:contact@herdingcats.fr"
                class="text-green-500 hover:underline focus:underline"
                >contact@herdingcats.fr</a
              >
            </li>
            <li>Par téléphone&nbsp;: +33 6 08 66 74 18</li>
            <li>
              Par courrier&nbsp;: 18 rue Pasteur, 94270 Le Kremlin-Bicêtre,
              France
            </li>
            <li>SIRET de Blackfoot&nbsp;: 82012881700039</li>
            <li>Code NAF de Blackfoot&nbsp;: 6201Z</li>
          </ul>
          <br />
          <p>
            Cette politique de confidentialité est adaptée pour refléter les
            spécificités des applications HerdingCats et HerdingCam et peut être
            modifiée pour rester en conformité avec la législation en vigueur ou
            pour refléter les changements dans nos pratiques de traitement des
            données. Les utilisateurs seront informés de toute modification
            significative.
          </p>
          <h3 class="mt-4 text-2xl font-bold">
            Données collectées par l'application HerdingCats
          </h3>
          <p>
            L'application HerdingCats, éditée par la société Blackfoot, collecte
            divers types de données pour offrir et améliorer ses services. Voici
            le détail des données collectées&nbsp;:
          </p>
          <br />
          <ol class="list-decimal pl-6">
            <li>
              <strong>Données des chats</strong>&nbsp;: Via un collier connecté
              et l'application, nous collectons des données relatives au nom,
              sexe, race, âge, poids, type d'alimentation, environnement de vie
              du chat (appartement ou maison, présence d'un espace extérieur ou
              non) et activités.
            </li>
            <li>
              <strong>Données de l'utilisateur</strong>&nbsp;: Pour la création
              et la gestion du compte utilisateur, nous collectons le nom,
              prénom, adresse email et mot de passe.
            </li>
            <li>
              <strong>Analytics</strong>&nbsp;: Afin d'améliorer l'expérience
              utilisateur et le bon fonctionnement de l'application, nous
              collectons des données analytiques de manière anonyme.
            </li>
          </ol>
          <h3 class="mt-4 text-2xl font-bold">
            Données collectées par l'application HerdingCam
          </h3>
          <p>
            HerdingCam est une application distincte développée par Blackfoot,
            qui permet aux utilisateurs de filmer leurs chats. Les données
            collectées par HerdingCam sont spécifiques à cette
            application&nbsp;:
          </p>
          <br />
          <ol class="list-decimal pl-6">
            <li>
              <strong>Accès au screen record et à la caméra</strong>&nbsp;:
              HerdingCam demande l'accès au screen record et à la caméra de
              l'appareil pour permettre à l'utilisateur de filmer son chat.
            </li>
            <li>
              <strong>Accès au Bluetooth et aux notifications</strong>&nbsp;:
              L'application peut demander l'accès au Bluetooth et aux
              notifications pour fonctionner correctement.
            </li>
            <li>
              <strong>Stockage local</strong>&nbsp;: Toutes les données, y
              compris les vidéos enregistrées, sont stockées localement sur
              l'appareil de l'utilisateur. Aucune donnée n'est envoyée à des
              serveurs distants, à l'exception des vidéos qui sont
              volontairement envoyées par l'utilisateur sur un serveur distant
              (comme Google Drive) pour contribuer à l'entraînement de notre
              intelligence artificielle.
            </li>
            <li>
              <strong>Absence d'analytics</strong>&nbsp;: HerdingCam ne collecte
              pas de données analytiques. Les interactions avec l'application
              restent en local sans envoi de données à des serveurs externes.
            </li>
            <li>
              <strong>Localisation</strong>&nbsp;: L’accès à la localisation en
              background peut-être demandée pour accéder à la liste des
              appareils bluetooth environnants. Ces données ne sont ni
              communiquées au serveur ni stockées localement.
            </li>
          </ol>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
// COMPONENTS
import Navbar from "@/components/Navbar.vue";
import Footer from "@/components/Footer.vue";
import "@/assets/css/main.css";

export default {
  name: "app",
  components: {
    Navbar,
    Footer,
  },
  data: function () {
    return {
      heroVisibility: false,
    };
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      if ((this.isVisible = isVisible)) {
        this.heroVisibility = true;
      } else {
        this.heroVisibility = !this.heroVisibility;
      }
    },
  },
  metaInfo: {
    title: "HerdingCats - RGPD",
    meta: [
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      {
        name: "description",
        content:
          "Politique de confidentialité et protection des données personnelles d'HerdingCats selon le RGPD et la loi Informatique et Libertés.",
      },

      // OpenGraph data
      {
        property: "og:title",
        content: "HerdingCats - RGPD",
      },
      {
        property: "og:site_name",
        content: "HerdingCats",
      },
      {
        property: "og:type",
        content: "website",
      },
      {
        property: "og:url",
        content: "https://herdingcats.fr/rgpd",
      },
      {
        property: "og:image",
        content: "https://herdingcats.fr/rgpd-opengraph.jpg",
      },
      {
        property: "og:description",
        content:
          "Politique de confidentialité et protection des données personnelles d'HerdingCats selon le RGPD et la loi Informatique et Libertés.",
      },

      // Twitter card
      {
        name: "twitter:card",
        content: "summary_large_image",
      },
      {
        name: "twitter:site",
        content: "https://herdingcats.fr",
      },
      {
        name: "twitter:title",
        content: "HerdingCats - RGPD",
      },
      {
        name: "twitter:description",
        content:
          "Politique de confidentialité et protection des données personnelles d'HerdingCats selon le RGPD et la loi Informatique et Libertés.",
      },
      {
        name: "twitter:image:src",
        content: "https://herdingcats.fr/twittercard.jpg",
      },

      // Schema.org markup
      {
        itemprop: "name",
        content: "HerdingCats - RGPD",
      },
      {
        itemprop: "description",
        content:
          "Politique de confidentialité et protection des données personnelles d'HerdingCats selon le RGPD et la loi Informatique et Libertés.",
      },
      {
        itemprop: "image",
        content: "https://herdingcats.fr/opengraph.jpg",
      },
    ],
  },
};
</script>
